import { SceneService } from "src/app/services/scene/scene.service";
import { ActionsEnum } from "../ActionsEnum";
import { ButtonInterface } from "../buttons/ButtonInterface";
import { MenuGeneric } from "./MenuGeneric";

export class MenuItemBasic implements MenuGeneric {
  protected showingItems = false;

  constructor(
    protected name: string,
    protected mesh,
    protected parentMesh,
    protected type: string,
    protected button: ButtonInterface = null,
    protected items: MenuItemBasic[] = [],
  ) {}

  setMenu(items){
    this.items = items;
  }

  setButton(button){
    this.button = button;
  }

  getButton(): ButtonInterface {
    return this.button;
  }
  setClicked(clicked: boolean) {
    throw new Error("Method not implemented.");
  }

  getName() {
    return this.name;
  }

  getMesh() {
    return this.mesh;
  }

  getParentMesh() {
    return this.parentMesh;
  }

  getType() {
    return this.type;
  }

  getItems() {
    return this.items;
  }

  showItems() {
    this.showingItems = true;
  }

  hideItems() {
    this.showingItems = false;
  }

  areShowingItems() {
    return this.showingItems;
  }

  toggleShowItems() {
    //Sólo puedo mostrar los hijos, si tengo
    if (this.items && this.items.length > 0)
      this.showingItems = !this.showingItems;
  }

  public parentOfChild(child: any): unknown {
    if (this === child) {
      return true;
    }
    if (!this.items) {
      return false;
    }
    return this.items.map((item) => item.parentOfChild(child)).includes(true);
  }

  maybeChange(message) {
    this.items.forEach(element => {
      element.maybeChange(message);
    });
  }

  click(){
     //Me clickeo/desclickeo
     let clicked = this.getButton().isClicked();
     this.toggleShowItems();
     if (!clicked || (clicked && this.getButton().canUnclickByItself())){
      this.getButton().toogle();
     }
     if (!clicked) {
       //Oculto los hijos de mis hermanos y desclickeo a mis hermanos
       if (
        this.getButton().isClicked() &&
        this.getButton().canBrothersUnclick()
       ) {
         this.items
           .filter((each) => each !== this)
           .filter((each) => each.getButton().canBrothersUnclick())
           .forEach((each) => {
             //Escondo hijos de mis hnos
             each.hideItems();
             // each.setClicked(false);
             each.getButton().setClicked(false);
             //Esto debería ser recursivo (hijos de mis hijos)
             each.getItems().forEach((element) => {
               element.hideItems();
               //element.setClicked(false);
             });
           });
       }
     }
  }
}
